import React from 'react';
import { Box, Typography } from '@mui/material';
import { t } from 'i18next';

const AnnouncementBanner = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'primary.main',
        color: 'white',
        textAlign: 'center',
        py: 1,
        px: 2,
        width: '100%',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <Typography
        sx={{
          fontSize: '1.2rem',
          animation: 'slideText 12s linear infinite',
          whiteSpace: 'nowrap',
          '@keyframes slideText': {
            '0%': {
              transform: 'translateX(-65%)',
            },
            '100%': {
              transform: 'translateX(65%)',
            },
          },
        }}
      >
        🚧{' '}
        {t(
          'This website is currently under development. Some features may not be fully functional.'
        )}{' '}
        🚧
      </Typography>
    </Box>
  );
};

export default AnnouncementBanner;
